import { useEffect, useMemo, useState } from 'react';

import Utils from 'utils/utils';
import { IFilterValues } from 'models';

export const useDebouncedChange = (watchedValues: IFilterValues) => {
	const [values, setValues] = useState({} as IFilterValues);

	const handleDebouncedChange = useMemo(
		() =>
			Utils.debounce((values: IFilterValues) => {
				setValues(values);
			}, 250),
		[],
	);

	useEffect(() => {
		handleDebouncedChange(watchedValues);
	}, [handleDebouncedChange, watchedValues]);

	return {
		values,
	};
};
